import { render, staticRenderFns } from "./PO.vue?vue&type=template&id=6ca37a84&scoped=true"
import script from "./PO.vue?vue&type=script&lang=js"
export * from "./PO.vue?vue&type=script&lang=js"
import style0 from "./PO.vue?vue&type=style&index=0&id=6ca37a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca37a84",
  null
  
)

export default component.exports